<script>
import DataTableChipColumnVue from 'Support/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import ReportListType from 'Support/enums/ReportListTypes';

export default {
  name: 'ReportListType',
  extends: DataTableChipColumnVue,
  data() {
    return {
      options: ReportListType,
    };
  },
  methods: {
    prepareItem(item) {
      return {
        color: '#e9ecef',
        textColor: '#495057',
        label: item.label,
        value: item.value,
      };
    },
  },
};
</script>
